export default "__VITE_ASSET__c209eb27__"